module.exports = __webpack_public_path__ + "img/icomoon.6a6241d.svg";